import React from "react";
import { useParams } from "react-router-dom";
import { resetpassword } from "../api/authApi";
import IsValidSignUpData from "./ValidationChecker/signupValidation";
import AuthForm from "./common/authForm/AuthForm";



const ResetPassword = () => {
    const { token } = useParams();

    const handleSubmit = (values, callback) => {
        resetpassword(token, values, callback);
    };

    const customFields = [
        {
            name: "password",
            type: "password",
            placeholder: "New Password",
            label: "Password",
        },
        {
            name: "confirm_password",
            type: "password",
            placeholder: "Confirm Password",
            label: "Confirm Password",
        },
    ];

    return (
        <AuthForm
            formType="Reset Password"
            initialValues={{ password: "", confirm_password: "" }}
            validationFunc={IsValidSignUpData}
            onSubmit={handleSubmit}
            successRedirectPath="/login"
            buttonLabel="Reset Password"
            loadingLabel="Resetting..."
            customFields={customFields}
            subTitle = "Create a new password for your account"
        />
    );
};

export default ResetPassword;
